/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
// import cx from "classnames";
import ReactGA from "react-ga";
import { withRouter } from "react-router-dom";

import axios from "axios";
import classes from "./FormSelectYourSeat.module.scss";
// import colours from "./SeatingMap.module.scss";
import FormTitle from "../FormTitle/FormTitle";
import * as ROUTES from "../../constants/routes";
import FormController from "../../components/FormController/FormController";
import SelectNumOfSeatsModal from "./SelectNumOfSeatsModal/SelectNumOfSeatsModal";
// import SeatingMap from "./SeatingMap";
import SeatMapModal from "./SeatMapModal";
// import Spinner from "../Loader/Spinner";
import Map3D from "./Map3D.js";
import { API_URL } from "../../config";

class FormSelectYourSeat extends Component {
  componentDidMount() {
    this.setState({
      seatInfoSelectedKey: "",
      seatDropdown: false,
      showMapModal: false,
    });
    this.props.updateMultipleSelectedChoices({
      seatInfoSelected: "",
    });
    if (this.props.formStart === "") {
      this.props.history.push("/");
    } else {
    }

    ReactGA.pageview("/select-your-seats");

    // set number of seats to 1
    this.props.updateSelectedChoices("numOfSeat", 1);
    // disable modal
    if (this.props.formStyle !== "ballpark") {
      this.setState({
        numOfSeatsModalConfirm: true,
      });
    }
    // getting available seats
    if (this.props["selectYourSeatsUuid"] !== "") {
      axios
        .post(`${API_URL}/getAvailability`, {
          uuid: this.props["selectYourSeatsUuid"],
          q: this.props.numOfSeat !== "" ? this.props.numOfSeat : 1,
        })
        .then((response) => {
          if (response.data.status !== "error") {
            this.setState({ seatsInfo: response.data.info, error: false });
            this.props.updateSelectedChoices(
              "seatInfoSelected",
              response.data.info[0]
            );
          } else {
            console.log("error", response.data.message);

            this.setState({ error: true });
          }
        })
        .catch((error) => {
          console.log("error", error);
          this.setState({ error: true });
        });
    }

    this.createplans();
  }

  async createplans() {
    if (this.props.cms) {
      let _planSchedules = {};

      const cms = this.props.cms;

      await cms.forEach(async (style, index) => {
        await style.plans.forEach((plan) => {
          plan.schedules.forEach((schedule) => {
            _planSchedules[schedule.UUID] = {
              planTitle: plan.name,
              planName: schedule.name,
              adaLink: schedule.adaUrl,
              switchPlanMsg: schedule.switchPlanMsg,
              flexMultiply: schedule.flexMultiply || 1,
              planSubTitle: plan.planSubTitle,
            };
          });
        });
      });
      this.setState({
        planSchedules: _planSchedules,
      });

      if (window.adobeAnalytics) {
        let planTitle =
          _planSchedules[this.props.selectYourSeatsUuid]?.planTitle;
        let planName = _planSchedules[this.props.selectYourSeatsUuid]?.planName;

        window.adobeAnalytics.t({
          pageName:
            "Washington Nationals: Tickets: Nationals Ticketfinder: Select your seats",
          products: `Washington Nationals; ${planTitle} (${planName});`,
        });
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.numOfSeats !== this.state.numOfSeats ||
      prevProps.selectYourSeatsUuid !== this.props.selectYourSeatsUuid
    ) {
      axios
        .post(`${API_URL}/getAvailability`, {
          uuid: this.props["selectYourSeatsUuid"],
          q: this.props.numOfSeat !== "" ? this.props.numOfSeat : 1,
        })
        .then((response) => {
          if (response.data.status !== "error") {
            this.setState({ seatsInfo: response.data.info, error: false });
            this.props.updateSelectedChoices(
              "seatInfoSelected",
              response.data.info[0]
            );
          } else {
            console.log("error", response.data.message);

            this.setState({ error: true });
          }
        })
        .catch((error) => {
          console.log("error", error);
          this.setState({ error: true });
        });
    }
  }
  onClickDifferentPlan = () => {
    if (this.props.formSize === "fortyClassic") {
      this.setState({
        loaderShow: true,
      });
      setTimeout(() => {
        this.setState({
          loaderShow: false,
        });
      }, 1000);
      if (this.props.selectYourSeatsUuid === "zN6VE3n0B5") {
        this.props.updateSelectedChoices("selectYourSeatsUuid", "CAFbHgRVNg");
      } else {
        this.props.updateSelectedChoices("selectYourSeatsUuid", "zN6VE3n0B5");
      }
    } else {
      this.props.history.push({
        pathname: "recommended-plan",
        state: { showModal: true },
      });
    }
    // this.props.history.push({
    //   pathname: "recommended-plan",
    //   state: { showModal: true },
    // });
  };
  // onClickSelectSeat = (index) => {
  //   this.setState({
  //     seatInfoSelectedKey: index,
  //   });
  //   this.props.updateSelectedChoices(
  //     "seatInfoSelected",
  //     this.state.seatsInfo[index]
  //   );
  // };
  // onMouseEnterSeat = (index) => {
  //   this.setState({
  //     seatInfoHoveredKey: this.state.seatsInfo[index],
  //   });
  // };
  // onMouseOutSeat = (index) => {
  //   this.setState({
  //     seatInfoHoveredKey: null,
  //   });
  // };
  onClickNumOfSeatItem = (numOfSeats) => {
    this.setState({
      numOfSeats: numOfSeats,
    });
    this.props.updateSelectedChoices("numOfSeat", numOfSeats);
  };
  onClickNumOfSeatModalConfirm = () => {
    if (this.props.formSize === "ballPark") {
      this.setState((prevState) => ({
        numOfSeatsModalConfirm: !prevState.numOfSeatsModalConfirm,
      }));

      this.props.history.push("checkout");
    } else {
      this.setState((prevState) => ({
        numOfSeatsModalConfirm: !prevState.numOfSeatsModalConfirm,
      }));
    }
  };
  onClickToggleSeatDropdown = () => {
    this.setState((prevState) => ({
      seatDropdown: !prevState.seatDropdown,
    }));
  };
  onClickCloseMapModal = () => {
    this.setState({ showMapModal: false });
  };
  onClickOpenMapModal = () => {
    this.setState({ showMapModal: true });
  };
  state = {
    seatsInfo: "",
    error: false,
    seatInfoSelectedKey: "",
    numOfSeats: "",
    numOfSeatsModalConfirm: false,
    disableSubmit: true,
    loaderShow: false,
  };
  openChatPopUp = () => {
    window.chatBtn();
    if (window.adobeAnalytics && window.adobeAnalytics.tl) {
      window.adobeAnalytics.tl(
        true,
        "o",
        "Washington Nationals: Tickets: Nationals Ticketfinder: Select your seats",
        {
          prop12: "navigation",
          prop13:
            "Washington Nationals: Tickets: Nationals Ticketfinder: Select your seats",
          prop14: `chat with a representative click`,
          evar140: "Chat Now",
        }
      );
    }
  };
  toggleSubmit = (isDisable) => {
    setTimeout(() => {
      this.props.updateSelectedChoices("checkoutEnable", !isDisable);
    }, 200);
    this.setState({ disableSubmit: isDisable });
  };

  render() {
    if (!this.state.planSchedules) {
      return <p>Loading ...</p>;
    }

    if (this.state.error) {
      return (
        <>
          <div className={classes.errorMsg}>
            <p> Sorry! There is an error, please try again later.</p>
          </div>
          <FormController
            backTo={ROUTES.PAGE_5_LINK}
            nextTo="checkout"
            startOver={ROUTES.PAGE_1_LINK}
            showBack={true}
            showStartOver={true}
            showSkip={false}
            showSubmit={true}
            disableSubmit={this.state.disableSubmit}
          />
        </>
      );
    }

    let planTitle =
      this.state.planSchedules[this.props["selectYourSeatsUuid"]]?.planTitle;
    let planName =
      this.state.planSchedules[this.props["selectYourSeatsUuid"]]?.planName;
    let adaLink =
      this.state.planSchedules[this.props["selectYourSeatsUuid"]]?.adaLink;
    let switchPlanMsg =
      this.state.planSchedules[this.props["selectYourSeatsUuid"]]
        ?.switchPlanMsg;
    let flexMultiply =
      this.state.planSchedules[this.props["selectYourSeatsUuid"]]?.flexMultiply;

    return this.props["selectYourSeatsUuid"] !== "" ? (
      <div>
        <FormTitle title="Select Your Seats" />
        {this.props.formStyle === "classic" &&
          this.props.planType === "premier" && (
            <div className={classes.subTitle}>
              *a $20 processing fee will be added PER SEAT to all packages at
              checkout
            </div>
          )}
        {this.props.formStyle === "classic" &&
          this.props.planType === "small" && (
            <div className={classes.subTitle}>
              *a $12.50 processing fee will be added PER SEAT to all packages at
              checkout
            </div>
          )}
        {this.props.formStyle === "flexible" &&
          (this.props.formSize === "eightyFlexible" ||
            this.props.formSize === "fortyFlexible") && (
            <div className={classes.subTitle}>
              *a $40 processing fee will be added to all packages at checkout
            </div>
          )}

        {this.props.formStyle === "flexible" &&
          this.props.formSize === "twentyFlexible" && (
            <div className={classes.subTitle}>
              *a $25 processing fee will be added to all packages at checkout
            </div>
          )}

        <div className={classes.FormSelectYourSeat}>
          <Map3D
            seatsInfo={this.state.seatsInfo}
            seatInfoSelectedKey={this.state.seatInfoSelectedKey}
            loaderShow={this.state.loaderShow}
            formStyle={this.props.formStyle}
            numOfSeat={this.props.numOfSeat}
            parentClasses={classes}
            flexMultiply={flexMultiply}
            planTitle={planTitle}
            planName={planName}
            adaLink={adaLink}
            switchPlanMsg={switchPlanMsg}
            history={this.props.history}
            uuid={this.props["selectYourSeatsUuid"]}
            updateSelectedChoices={this.props.updateSelectedChoices}
            toggleSubmit={this.toggleSubmit}
          />

          <div className={classes.thirdCol}>
            {switchPlanMsg && switchPlanMsg !== "" ? (
              <div
                className={classes.differentPlan}
                onClick={() => this.onClickDifferentPlan()}
              >
                <div className={classes.smallTitle}>Switch Your Schedule</div>
                <div className={classes.description}>{switchPlanMsg}</div>
                <div className={classes.blueButton}>Switch Plan</div>
              </div>
            ) : (
              ""
            )}

            <div className={classes.premiumSales}>
              <div className={classes.smallTitle}>
                Interested in Premium Seats?
              </div>
              <div className={classes.description}>
                Click here to chat with a Nationals representative about Premium
                seating options with all-inclusive food & beverage and access to
                exclusive indoor club areas
              </div>
              <a onClick={this.openChatPopUp} className={classes.blueButton}>
                Chat Now
              </a>
            </div>
            {this.props.formStyle === "classic" && (
              <div className={classes.ada}>
                <div className={classes.smallTitle}>
                  Interested in ADA Seats?
                </div>

                <div className={classes.description}>
                  Click here to view ADA accessible seating options
                </div>
                <a
                  href={adaLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.blueButton}
                >
                  View ADA Seats
                </a>
              </div>
            )}

            {/* {this.props.formStyle === "flexible" && (
              <div className={classes.ada}>
                <div className={classes.smallTitle}>
                  {this.state.numOfSeats}{" "}
                  {this.state.numOfSeats < 2 ? "Plan" : "Plans"}
                </div>

                <div className={classes.description}>
                  Click to update the amout of plan
                </div>

                <a
                  onClick={() =>
                    this.setState({
                      numOfSeatsModalConfirm: false,
                    })
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  className={classes.blueButton}
                >
                  Update
                </a>
              </div>
            )} */}
          </div>
        </div>
        <FormController
          backTo={ROUTES.PAGE_5_LINK}
          nextTo="checkout"
          startOver={ROUTES.PAGE_1_LINK}
          showBack={true}
          showStartOver={true}
          showSkip={false}
          showSubmit={true}
          disableSubmit={this.state.disableSubmit}
        />
        <SelectNumOfSeatsModal
          onClickNumOfSeatItem={this.onClickNumOfSeatItem}
          numOfSeatsSelected={this.state.numOfSeats}
          seatInfoSelected={this.props.seatInfoSelected}
          numOfSeatsModalConfirm={this.state.numOfSeatsModalConfirm}
          onClickNumOfSeatModalConfirm={this.onClickNumOfSeatModalConfirm}
          formStyle={this.props.formStyle}
        />
        <SeatMapModal
          showMapModal={this.state.showMapModal}
          seatsInfo={this.state.seatsInfo}
          seatInfoSelectedKey={this.state.seatInfoSelectedKey}
          hoveredItem={this.state.seatInfoHoveredKey}
          onClickCloseMapModal={this.onClickCloseMapModal}
        />
      </div>
    ) : (
      <div className={classes.errorMsg}>Please select the correct plan</div>
    );
  }
}
export default withRouter(FormSelectYourSeat);
